import type { Admin } from "../../../../lib/admin-data"
import { AdminTableRow } from "./admin-table-row"
import { PaginationStats } from "../students-management/pagination-stats"

interface AdminTableProps {
  admins: Admin[]
  onEdit: (admin: Admin) => void
  onDelete: (id: string) => void
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export function AdminTable({ admins, onEdit, onDelete, currentPage, totalPages, onPageChange }: AdminTableProps) {
  const resultsPerPage = 10
  const totalResults = admins.length * totalPages

  return (
    <div className="bg-card rounded-xl shadow-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-muted border-b border-border">
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Staff Name</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Role</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Department</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Permissions</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Status</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase text-right">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {admins.map((admin) => (
              <AdminTableRow key={admin.id} admin={admin} onEdit={onEdit} onDelete={onDelete} />
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-5 py-4 border-t border-border">
        <PaginationStats
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalResults}
          resultsPerPage={resultsPerPage}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}
